/* eslint-disable no-undef */
import makeRequest from '@lib/fetchService';

const chatbotFeedbackForm = () => {
  const submitFeedbackButton = document.querySelector(
    '.js-submit-chatbot-feedback-button'
  );
  const submitFormWrapper = document.querySelector(
    '.chatbot-feedback-form-popup__submit-form-wrapper'
  );
  const confirmationWrapper = document.querySelector(
    '.chatbot-feedback-form-popup__confirmation_wrapper'
  );
  const chatbotFeedbackReveal = document.querySelector(
    '#chatbot-feedback-form-popup'
  );
  const path = document.getElementById('chatbot-feedback-form-popup').dataset
    .path;
  const textResponseInput = document.querySelector('.js-text-response');

  const toggleSubmitButton = () => {
    submitFeedbackButton.disabled = !textResponseInput.value.trim();
  };

  textResponseInput.addEventListener('input', toggleSubmitButton);

  const resetForm = () => {
    submitFormWrapper.classList.remove('is-hidden');
    confirmationWrapper.classList.add('is-hidden');
    document.querySelector('.js-text-response').value = '';
    document.getElementById('approve-contact').checked = false;
    submitFeedbackButton.disabled = true;
  };

  if (chatbotFeedbackReveal) {
    $(chatbotFeedbackReveal).on('closed.zf.reveal', resetForm);
  }

  const handleSubmitFeedback = async () => {
    const textResponse = document.querySelector('.js-text-response').value;
    const approvedContact = document.getElementById('approve-contact').checked;

    const payload = {
      survey_type: 'sofabuddy_feedback',
      text_response: textResponse,
      options: {
        approved_contact: approvedContact
      }
    };

    try {
      await makeRequest(path, 'POST', payload);

      submitFormWrapper.classList.add('is-hidden');
      confirmationWrapper.classList.remove('is-hidden');
    } catch (error) {
      console.error('Failed to submit feedback:', error);
    }
  };

  submitFeedbackButton?.addEventListener('click', handleSubmitFeedback);

  preventCachedExecution(() => {
    new Foundation.Reveal($('#chatbot-feedback-form-popup'));
  });
};

document.addEventListener('turbolinks:before-visit', () => {
  Turbolinks.clearCache();
});

preventCachedExecution(() => {
  if (document.querySelector('#chatbot-feedback-form-popup')) {
    chatbotFeedbackForm();
  }
});
